import { AuthApi, Configuration, LocationsApi, TabsApi } from '@/openapi'
import { useAuthStore } from '@/store/auth'

const baseURL = (import.meta.env.VITE_API_BASE_URL as string)?.replace(/\/$/, '') ?? ''

const configuration = new Configuration({
  basePath: `${baseURL}/riders`,
  middleware: [
    {
      pre: async ctx => {
        const auth = useAuthStore()
        const headers: Record<string, string> = {}

        if (auth.accessToken) {
          headers['Authorization'] = auth.accessToken
        }

        if (auth.selectedLocationId) {
          headers['Location-ID'] = auth.selectedLocationId
        }

        if (auth.selectedOrganizationId) {
          headers['Organization-ID'] = auth.selectedOrganizationId
        }

        ctx.init.headers = {
          ...ctx.init.headers,
          ...headers
        }

        return ctx
      },
      post: async ctx => {
        if (ctx.response.status === 401) {
          const auth = useAuthStore()
          await auth.logout()
        }
        return ctx.response
      }
    }
  ]
})

export const authApi = new AuthApi(configuration)
export const locationsApi = new LocationsApi(configuration)
export const tabsApi = new TabsApi(configuration)
